// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_checkpoint_model from "./web_checkpoint_model.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__Option from "melange/option.js";

function view(model, send) {
  const source = Signal.map((function (m) {
    return m.checkpoint;
  }), model);
  const partial_arg = "Parent checkpoint";
  const partial_arg$1 = 2;
  const partial_arg$2 = Signal.map((function (p) {
    return p.message !== "";
  }), source);
  const partial_arg$3 = Signal.map((function (p) {
    return Mapre_web__Web_checkpoint_model.child(p) === undefined;
  }), source);
  const partial_arg$4 = {
    TAG: /* Checkpoint */ 46,
    _0: /* Retry */ 2
  };
  const partial_arg$5 = (function (param) {
    return Lui_elements.press(send, partial_arg$4, param);
  });
  const partial_arg$6 = "outline";
  const partial_arg$7 = "Retry same checkpoint";
  const partial_arg$8 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$9 = Signal.map((function (p) {
    return Stdlib__Option.fold(false, (function (a) {
      return a.uncertain;
    }), p.attempt);
  }), source);
  const partial_arg$10 = {
    TAG: /* Checkpoint */ 46,
    _0: /* Child */ 4
  };
  const partial_arg$11 = (function (param) {
    return Lui_elements.press(send, partial_arg$10, param);
  });
  const partial_arg$12 = "primary";
  const partial_arg$13 = "Create child session";
  const partial_arg$14 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$15 = Signal.map((function (p) {
    return Mapre_web__Web_checkpoint_model.child(p) !== undefined;
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.if_(partial_arg$3, (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___003_) {
        const partial_arg = {
          TAG: /* Checkpoint */ 46,
          _0: /* Submit */ 1
        };
        const partial_arg$1 = (function (param) {
          return Lui_elements.press(send, partial_arg, param);
        });
        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (p) {
          return !Mapre_web__Web_checkpoint_model.can_submit(p);
        }), source)));
        const partial_arg$3 = "outline";
        const partial_arg$4 = "Save parent checkpoint";
        return function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$9, partial_arg$8, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$15, partial_arg$14, param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$16 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$17 = 8;
  const partial_arg$18 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$17, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$16, param, param$1);
  };
  const partial_arg$19 = Signal.map(Mapre_web__Web_model.can_create, model);
  const partial_arg$20 = {
    TAG: /* Checkpoint */ 46,
    _0: /* Refresh */ 3
  };
  const partial_arg$21 = (function (param) {
    return Lui_elements.press(send, partial_arg$20, param);
  });
  const partial_arg$22 = "outline";
  const partial_arg$23 = "Refresh checkpoint";
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___001_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map(Mapre_web__Web_checkpoint_model.progress, source)));
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$2, (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___002_) {
            const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (p) {
              return p.message;
            }), source)));
            const partial_arg$1 = "notice";
            return function (param, param$1) {
              return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }), param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$19, partial_arg$18, param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$23, undefined, partial_arg$22, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$21, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          }),
          tl: /* [] */ 0
        }
      }
    }
  };
  const partial_arg$24 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$25 = "form-card";
  const partial_arg$26 = 0;
  const partial_arg$27 = 16;
  const partial_arg$28 = 10;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$28, undefined, undefined, undefined, undefined, undefined, partial_arg$27, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$26, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$25, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$24, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
